import React from 'react';
import Header from '../components/Header';
import Footer from '../components/Footer';

const Privacy = () => {
  return (
    <div className="min-h-screen bg-[#F9F6EF]">
      <Header currentPage="privacy" />
      
      <section className="pt-32 pb-20">
        <div className="max-w-3xl mx-auto px-6">
          <h1 className="text-3xl sm:text-4xl font-light text-white mb-2">Privacy Policy</h1>
          <p className="text-[#888] text-sm mb-12">Mundalo – Last Updated: March 23, 2026</p>
          
          <p className="text-[#ccc] text-sm mb-8 leading-relaxed">
            We respect your privacy. This policy explains how we collect, use, and protect your information.
          </p>
          
          <div className="prose prose-invert max-w-none space-y-8 text-[#ccc]">
            <section>
              <h2 className="text-xl text-white font-medium mb-3">1. Information We Collect</h2>
              <ul className="text-sm leading-relaxed space-y-2 list-disc list-inside">
                <li><strong className="text-white">Personal:</strong> name, email, phone (from intake form / signup)</li>
                <li><strong className="text-white">Usage:</strong> IP address, browser type, pages visited</li>
                <li><strong className="text-white">Payment:</strong> processed securely via Stripe (we do not store card details)</li>
              </ul>
            </section>

            <section>
              <h2 className="text-xl text-white font-medium mb-3">2. How We Use Information</h2>
              <ul className="text-sm leading-relaxed space-y-2 list-disc list-inside">
                <li>Provide and improve services (generate Blueprint, populate checklist)</li>
                <li>Send onboarding emails and updates</li>
                <li>Process payments and subscriptions</li>
                <li>Internal analytics and fraud prevention</li>
              </ul>
            </section>

            <section>
              <h2 className="text-xl text-white font-medium mb-3">3. Sharing Information</h2>
              <p className="text-sm leading-relaxed mb-2">We do not sell your data. We may share with:</p>
              <ul className="text-sm leading-relaxed space-y-2 list-disc list-inside">
                <li>Stripe (payment processing)</li>
                <li>Third-party AI providers (GPT-4o) – anonymized inputs only</li>
                <li>Service providers under strict confidentiality</li>
              </ul>
            </section>

            <section>
              <h2 className="text-xl text-white font-medium mb-3">4. Cookies & Tracking</h2>
              <p className="text-sm leading-relaxed">
                We use essential cookies for functionality. Affiliate links may set third-party cookies (you can manage in browser settings).
              </p>
            </section>

            <section>
              <h2 className="text-xl text-white font-medium mb-3">5. Your Rights</h2>
              <p className="text-sm leading-relaxed">
                You may request access, correction, or deletion of your data by emailing <a href="mailto:hello@mundalo.com" className="text-[#2CA8A0] hover:underline">hello@mundalo.com</a>.
              </p>
            </section>

            <section>
              <h2 className="text-xl text-white font-medium mb-3">6. Data Security</h2>
              <p className="text-sm leading-relaxed">
                We use industry-standard security (HTTPS, JWT tokens, encrypted storage). No system is 100% secure.
              </p>
            </section>

            <section>
              <h2 className="text-xl text-white font-medium mb-3">7. Children</h2>
              <p className="text-sm leading-relaxed">
                Our services are not directed to persons under 18.
              </p>
            </section>

            <section>
              <h2 className="text-xl text-white font-medium mb-3">8. Changes</h2>
              <p className="text-sm leading-relaxed">
                We may update this policy. Continued use constitutes acceptance.
              </p>
            </section>

            <section className="pt-6 border-t border-[#222]">
              <p className="text-sm">Contact: <a href="mailto:hello@mundalo.com" className="text-[#2CA8A0] hover:underline">hello@mundalo.com</a></p>
            </section>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default Privacy;
